import type { Territory } from '@amzn/vinyl-amzn'
import { getMarketplace } from '@/marketplace'
import { type WeblabMarketplace, weblabMarketplace } from '@/territory'

// GH's video-on-demand weblab is T1 here and off in AV_ROW_EU, AV_ROE, AV_ROW_NA and AV_ROW_FE.
const VIDEO_ON_DEMAND_MARKETPLACES: ReadonlySet<WeblabMarketplace> = new Set<WeblabMarketplace>([
    'US',
    'CA',
    'MX',
    'BR',
    'GB',
    'DE',
    'FR',
    'IT',
    'ES',
    'IN',
    'JP',
    'AU',
])

/** Whether video on demand is offered in the territory's marketplace, as GH's video-on-demand weblab allocates it. */
export function isVideoOnDemandMarket(territory: Territory): boolean {
    return VIDEO_ON_DEMAND_MARKETPLACES.has(weblabMarketplace(territory))
}

/** Whether the current marketplace offers video on demand: the account's territory once known, else the page host's. */
export async function videoOnDemandEnabled(): Promise<boolean> {
    return isVideoOnDemandMarket((await getMarketplace()).musicTerritory)
}
